import { isObject, mergeDeep } from './mergeDeep'

export const getImmediateLocale = (locale: Record<string, unknown>, translationsTemplate: Record<string, unknown>) => {
  try {
    return isObject(locale) && Object.keys(locale).length > 0 ? mergeDeep(locale, translationsTemplate) : { ...translationsTemplate }
  } catch (error) {
    console.error('Error in getImmediateLocale', error)
    return translationsTemplate
  }
}
